<template>
  <a-card class="p-4">
    <div class="flex w-full flex-wrap justify-center md:justify-start lg:justify-start">
      <a-avatar
        :text="student.last_name"
        size="64px"
        class="rounded-full mx-auto md:mx-0 md:mr-6 w-full md:w-16 lg:w-16 text-center" />

      <div class="flex flex-col items-center md:items-start lg:items-start" style="flex-grow: 1;">
        <p class="text-lg w-auto md:w-full lg:w-full dark:text-white">
          <b class="dark:text-white">Nombres</b>: {{ student.last_name + ', ' }} {{ student.first_name }}
        </p>
        <p class="text-md w-auto md:w-full lg:w-full dark:text-white">
          <b class="dark:text-white">Email</b>: {{ student.email }}
        </p>
      <p class="text-md w-auto md:w-full lg:w-full dark:text-white">
          <b class="dark:text-white">Email IDC</b>: {{ student.institution_email ? student.institution_email : '---' }}
        </p>
        <p class="text-md w-auto md:w-full lg:w-full dark:text-white">
          <b class="dark:text-white">Cédula</b>: {{ student.id_document }}
        </p>
      </div>
      <div class="flex flex-wrap -mx-2 w-full mt-3">
        <div class="px-2 w-1/2">
          <p class="dark:text-white">
            <b class="dark:text-white">Género</b>: {{ student.gender === 'male' ? 'Masculino' : 'Femenino' }}
          </p>
          <template v-if="!user.isTeacher && control === 0">
            <p class="dark:text-white">
              <b class="dark:text-white">Período</b>: {{ findPeriod(student.latest_inscription.period) }}
            </p>
            <p class="dark:text-white" v-if="!user.isTeacher && control === 0">
              <b class="dark:text-white">Semestre</b>: {{ student.inscriptions.filter((a) => a.period_id === student.latest_inscription.period_id).map((a) => a.semester.number).sort((a, b) => a - b).join(' - ') }}
            </p>
          </template>
        </div>
        <div class="px-2 w-1/2 items-end flex flex-col">
          <p class="dark:text-white">
            <b class="dark:text-white">Turno</b>: {{ getSheduleShift(student.schedule_shift) }}
          </p>
          <template v-if="!user.isTeacher && control === 0">
            <p v-if="student.latest_inscription.section" class="dark:text-white">
              <b class="dark:text-white">Sección</b>: {{ student.inscriptions.filter((a) => a.period_id === student.latest_inscription.period_id).sort((a, b) => a.semester.number - b.semester.number).map((a) => a.section.letter_code).join(' - ') }}
            </p>
          </template>

        </div>
        <div class="px-2" v-if="!user.isTeacher && control === 0">
          <p class="dark:text-white">
            <b class="dark:text-white">Fecha de inscripción</b>: {{ student.latest_inscription.created_at | date }}
          </p>
          <p class="dark:text-white">
            <b class="dark:text-white">Especialidad</b>:
            {{ student.latest_inscription.specialization.title }}
          </p>
        </div>
      </div>
    </div>
    <div class="flex flex-col mt-3 items-center md:items-end lg:items-end">
      <div v-if="!user.isStudent" class="flex flex-wrap space-x-4">
        <router-link
          v-tooltip="`Ver estudiante`"
          class="text-primary"
          v-if="user.isAdminGroup || user.isTeacherGroup || (courseSection.course_id && courseSection.section_id)"
          :to="studentsLink">
          <a-icon name="eye" />
        </router-link>
        <a-dropdown right v-if="user.isAdmin && student.latest_inscription.section">
          <button
  class="text-primary"
  v-tooltip="`Cambiar de sección`"
  @click="showModal = true">
  <a-icon name="exchange" />
</button>
<!-- 
          <template #menu>
            <a-dropdown-item v-if="loadingSections">
              <a-loader class="mr-2 h-6 w-6" /> Cargando...
            </a-dropdown-item>
            <a-dropdown-item v-else-if="!mappedSections.length">
              No hay secciones disponibles
            </a-dropdown-item>
            <template v-else>
              <a-dropdown-item v-for="section in mappedSections" :key="section.id" class="w-full" @click="changeSection({ student, section, context: 'pagination' })">
                {{ section.specialization.title }} - {{ section.letter_code }}
              </a-dropdown-item>
            </template>
          </template> -->
        </a-dropdown>
      </div>
    </div>
    <a-modal
  :show="showModal"
  title="Cambiar Sección"
  @cancel="closeModal"
  @confirm="handleChangeSection"
  :width="600"
  :body-style="{ padding: '20px', background: '#f9f9f9' }"
  
>
  <div class="space-y-6">
    <!-- Selector de semestres -->
    <p>Seleccione un semestre:</p>
    <a-select
      v-model="selectedSemester"
      :source="semesterOptions"
      placeholder="Seleccione un semestre"
      class="w-full mb-6" 
      
    />

    <!-- Selector de secciones -->
    <template v-if="sectionOptions.length">
      <p>Seleccione una sección:</p>
      <p class="text-sm text-gray-500">El estudiante se encuentra actualmente en: {{ currentSectionLabel }}</p>      <a-select
        v-model="selectedSection"
        :source="sectionOptions"
        placeholder="Seleccione una sección"
        class="w-full mb-6"
        :disabled="!selectedSemester"
      />
    </template>
    <template v-else>
      <p class="text-red-500">No hay secciones disponibles para este semestre.</p>
    </template>
  </div>
</a-modal>



  </a-card>
</template>

<script>
import Vue from 'vue';
import { mapActions } from 'vuex'
export default {
    props: {
        user: { required: true, type: Object },
        student: { required: true, type: Object },
        query: { required: true, type: Object },
        sections: { required: false, type: Array, default: () => [] },
        loadingSections: { required: false, type: Boolean, default: false },
        courseSection: { required: false, type: Object, default: () => ({}) },
        control: { required: false, type: Number }
    },
    data: () => ({
      showModal: false,
      selectedSemester: null,
      selectedSection: null,
  }),
  query: {
      limit: 10,
      semester: null,
      section: null,
    },
    computed: {
      currentSectionLabel() {
  if (!this.selectedSemester) {
    return 'Seleccione un semestre primero';
  }

  // Log para identificar conflictos potenciales
  console.log('Conflictos potenciales:', this.student.inscriptions.filter(
    inscription => inscription.semester.id === this.selectedSemester
  ));

  const currentInscription = this.student.inscriptions.find(
    (inscription) => 
      inscription.semester.id === this.selectedSemester && 
      inscription.period_id === this.student.latest_inscription.period_id
  );

  return currentInscription?.section?.letter_code
    ? `Sección ${currentInscription.section.letter_code}`
    : 'Sin sección asignada';
},
   semesterOptions() {
    return this.student.inscriptions?.filter((a) => a.period_id === this.student.latest_inscription.period_id).map((a) => ({label: `Semestre ${a.semester.number}`, value: a.semester.id}))
        
  },
  sectionOptions() {
  if (!this.selectedSemester) {
    console.log('No se ha seleccionado un semestre.');
    return [];  
  }

  console.log('Semestre seleccionado:', this.selectedSemester);

  return this.sections
    .filter(($0) => {
      const isSameSemester = $0.semester_id === this.selectedSemester;
      const isSameSpecialization = $0.specialization_id === this.student.latest_inscription.specialization_id;
      const isSamePeriod = $0.period_id === this.student.latest_inscription.period_id;
      const isNotAssignedSection = !this.student.inscriptions.some((inscription) => 
        inscription.section.id === $0.id &&
        inscription.semester.id === $0.semester_id
      );


      return isSameSemester && isSameSpecialization && isSamePeriod && isNotAssignedSection;
    })
    .map(($0) => ({
      label: `Seccion ${$0.letter_code}`,
      value: $0.id,
    }));
},

        mappedSections() {
            const {
              specialization_id,
              period_id,
              semester,
              section
            } = this.student.latest_inscription

            return this.sections.filter($0 => $0.specialization_id === specialization_id
              && $0.period_id === period_id
              && $0.semester.number === semester.number
              && $0.id !== section.id
            )
        },
        studentsLink() {
            let baseRoute = { name: 'student', params: { student: parseInt(this.student.id) } }
            if (this.user.isCoordinator) {
                baseRoute = { name: 'student', params: { student: parseInt(this.student.id) } }
            }
            if (this.user.isTeacher) {
                baseRoute.name = 'section_course_student'
                baseRoute.params = {
                  ...baseRoute.params,
                  course: this.courseSection.course_id,
                  section: this.courseSection.section_id,
                }
            }

            return baseRoute
        }
    },
    methods: {
       handleChangeSection() {
  try {
    if (!this.selectedSemester || !this.selectedSection) {
      this.$message.error('Debe seleccionar un semestre y una sección para continuar.');
      return;
    }

    console.log('Payload:', {
      student: this.student,
      semester: this.selectedSemester,
      section: this.selectedSection,
      context: 'manual',
    });
    console.log('Cambio de sección exitoso');
    Vue.prototype.$confirm({
                    message: `¿Desea cambiar a este estudiante de sección?`,
                    button: {
                        no: 'No',
                        yes: 'Si'
                    },
                    callback: confirm => {
                        if (confirm) {
                            this.$repository.students
                                .changeSection(this.student.id, this.selectedSection, true)
                                .then(() => {
                                    Vue.prototype.$message.success({
                                        title: `Cambio de seccion exitoso`,
                                        message: `El estudiante ${this.student.first_name} ${this.student.last_name} ha sido cambiado de seccion`,
                                        
                                    })
                                    this.showModal = false
                                }).catch((err)=>{ 
                                  console.log(err.data)
                                 })
                        }
                    }
                })

 
  } catch (error) {
    console.error('Error:', error);
    this.$message.error('Error al cambiar la sección. Intente nuevamente.');
  }
},
        ...mapActions({
            changeSection: 'students/changeSection'
        }),
        openModal() {
    console.log('Abrir Modal');
    this.showModal = true;
  },
  closeModal() {
    console.log('Cerrar Modal');
    this.selectedSemester = null;
    this.selectedSection = null;
    this.showModal = false;
  },
        findPeriod(period) {
            // if (period) {
            //     return `${period.year}-${period.number}`
            // }
            // return '-'
          return period ? `${period.year}-${period.number}` : '-'
        },
        getSheduleShift(shift) {
           if (shift === 'morning') return 'Mañana';
           if (shift === 'afternoon') return 'Tarde';
           return 'Mixto'
        },
        // mappedSections(student) {
        //     const {
        //       specialization_id,
        //       period_id,
        //       semester
        //     } = student.latest_inscription
        //     // const {
        //     //     specialization_id,
        //     //     period_id,
        //     //     semester
        //     // } = student.latest_inscription
        //
        //     return this.sections.filter($0 =>{
        //         console.log($0.specialization_id === specialization_id
        //           && $0.period_id === period_id
        //           && $0.semester.number === semester.number
        //           && $0.id !== student.latest_inscription.section.id)
        //         return $0.specialization_id === specialization_id
        //             && $0.period_id === period_id
        //             && $0.semester.number === semester.number
        //             && $0.id !== student.latest_inscription.section.id
        //     }
        //         // $0.specialization_id === specialization_id
        //         // && $0.period_id === period_id
        //         // && $0.semester.number === semester.number
        //         // && $0.id !== student.latest_inscription.section.id
        //     )
        // },
    },
    watch: {
      selectedSemester(val){
        if(val){
          this.selectedSection = null;
        }
      }
    }
}
</script>
